/**
 * Shared name helpers. Same trio of utilities was inlined in 6+ places
 * (Header, PainelHeader, admin layout, EntityNameSwitcher, several
 * /painel/* pages). Consolidate so a future tweak — e.g. handling
 * mononyms or non-Latin scripts — lives in one file.
 */

/**
 * First word of a person/entity name. Falls back to the trimmed input
 * (or "Você") when the value is empty.
 */
export function firstName(value: string | null | undefined): string {
  const trimmed = (value ?? "").trim();
  if (!trimmed) return "Você";
  return trimmed.split(/\s+/)[0]!;
}

/**
 * Two-letter initials (first letter of the first + last word).
 * Single-word names get their first 2 letters. Empty input → "U".
 */
export function initials(value: string | null | undefined): string {
  const parts = (value ?? "").trim().split(/\s+/).filter(Boolean);
  if (parts.length === 0) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0]! + parts[parts.length - 1][0]!).toUpperCase();
}

/**
 * Alias of {@link firstName} that doesn't carry the user-facing
 * fallback. Use when you'd rather show an empty string than the
 * placeholder ("Verificações de {firstWord}" reads weird with "Você").
 */
export function firstWord(value: string | null | undefined): string {
  return (value ?? "").trim().split(/\s+/)[0] ?? "";
}
